import { render } from "./NavigationLink.vue?vue&type=template&id=013aec02&scoped=true"
import script from "./NavigationLink.vue?vue&type=script&lang=js"
export * from "./NavigationLink.vue?vue&type=script&lang=js"

import "./NavigationLink.vue?vue&type=style&index=0&id=013aec02&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013aec02"]])

export default __exports__